export const environment = {
    production: true,
    domainName: 'maxcondoclub.com',
    oauthUrl: 'https://auth.maxcondoclub.com',
    domainBD: 'https://building.maxcondoclub.com/api',
    domainParcels: 'https://parcels.maxcondoclub.com/api',
    domainEmails: 'https://mail.maxcondoclub.com',
    domainNotifications: 'https://notification.maxcondoclub.com/api',
    domainDocuments: 'https://documents.maxcondoclub.com',
    domainIncidentReports: 'https://incident-reports.maxcondoclub.com/api',
    domainKeyLog: 'https://key-log.maxcondoclub.com/api',
    domainServiceRequest: 'https://service-request.maxcondoclub.com/api',
    domainPassOnLog: 'https://pass-on-log.maxcondoclub.com/api',
    domainDailyReports: 'https://daily-reports.maxcondoclub.com/api',
    domainNpmiLink: 'https://auth.maxcondoclub.com/api',
    domainAmenities: 'https://amenity.maxcondoclub.com/api',
    domainParkingPass: 'https://parking-pass.maxcondoclub.com/api',
    domainReportGenerator: 'https://report-builder.maxcondoclub.com/api',
    domainCondomanager: 'https://condomanager-demo.maxcondoclub.com/api',
    domainClassifiedsMcc: 'https://key-log.maxcondoclub.com/api',
    domainPmi: 'https://maxtv.media',
    domainPmiNotice: 'https://announcements.maxtv.media',
    domainAnnouncements: 'https://announcements.maxcondoclub.com/api',
    domainVendors: 'https://api-vendors.maxcondoclub.com/api',
    domainQuotes: 'https://quote-wizard.maxcondoclub.com',
    domainCommunity: 'https://api-community.maxcondoclub.com/api',
    domainSms: 'https://sms-notification.maxcondoclub.com/api',
    domainLanding: 'https://landing.maxcondoclub.com',
    oauthClientId: '20aa5tpwg04ks4w84o8cookswwccgkwko40gwcs0ws840wkssk',
    oauthClientSecret: '79fqd7qzbp8g8o8oggss48w4kwck4s4kccwwk8804ksowg8o',
    stripeKey: 'pk_live_c8iIILKhU4r0IacEGr1mW17S'
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts